import React from 'react';

type Props = {
    className?: string;
};

export const UserIcon: React.FC<Props> = ({className}) => {
    return (
        <svg className={className} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M12.0059 12.309C15.6169 12.288 17.5609 10.338 17.6279 6.63798C17.5659 3.07798 15.5169 1.02398 11.9939 1.00098C8.43295 1.02298 6.37195 3.17098 6.37195 6.63798C6.37195 10.209 8.43395 12.289 12.0059 12.31V12.309ZM11.9939 2.99998C14.4309 3.01598 15.5849 4.18298 15.6279 6.63598C15.5809 9.19498 14.4949 10.293 12.0059 10.308C9.51095 10.293 8.42395 9.19998 8.37195 6.65398C8.42195 4.14298 9.54295 3.01498 11.9939 2.99998Z"
                fill="#AA76E1"/>
            <path
                d="M11.994 13.661C6.66605 13.695 3.79905 16.572 3.70305 21.983C3.69305 22.535 4.13305 22.991 4.68505 23.001C5.20105 22.982 5.69205 22.571 5.70305 22.019C5.77905 17.708 7.78305 15.688 11.994 15.662C16.162 15.689 18.224 17.768 18.298 22.018C18.308 22.564 18.754 23.001 19.298 23.001H19.316C19.868 22.991 20.308 22.536 20.299 21.984C20.207 16.651 17.263 13.696 11.995 13.662L11.994 13.661Z"
                fill="#AA76E1"/>
        </svg>
    )
}